import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=1a2a5a5a&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a5a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2a5a5a')) {
      api.createRecord('1a2a5a5a', component.options)
    } else {
      api.reload('1a2a5a5a', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=1a2a5a5a&scoped=true&", function () {
      api.rerender('1a2a5a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Marketing/Sidebar.vue"
export default component.exports